<template>
  <div>
    <label>{{ dataHora }}</label>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import 'moment/locale/pt-br'

export default {
    name: 'MostradorDataHora',
    data() {
        return {
            dataHora: '',
            intervalo: null
        }
    },
    mounted() {
        moment.locale('pt-br')
        this.atualizarDataHora()
        this.iniciarRelogio()
    },
    beforeDestroy() {
        this.pararRelogio()
    },
    methods: {
        atualizarDataHora() {
            this.dataHora = moment()
                .tz(this.$store.state.comum.timezone)
                .format('dddd, DD [de] MMMM [às] HH:mm:ss')
        },
        iniciarRelogio() {
            this.intervalo = setInterval(() => {
                this.atualizarDataHora()
            }, 1000)
        },
        pararRelogio() {
            if (this.intervalo) {
                clearInterval(this.intervalo)
                this.intervalo = null
            }
        }
    }
}
</script>

<style scoped lang="stylus">
label
  font-size 14px
  font-weight 500
</style>
